.meta-data-bar {
  align-items: center;
  background-color: var(--color-uva-white);
  color: var(--color-grey-700);
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding: 1rem;
  width: fit-content;
}

.meta-data-bar__item {
  align-items: center;
  display: flex;
  font-size: var(--font-size-text-non-essential);
  gap: 0.5rem;
  line-height: 1.5rem;
  white-space: nowrap;
}
